import { qs, listen, qsa } from "@fluorescent/dom";
import { on } from "@/glow/events";

export default function (container) {
  const quantityWrappers = qsa("[data-quantity-selector]", container);
  if (!quantityWrappers || quantityWrappers.length === 0) return;
  const events = [];
  const inputs = [];

  const updateAllInputs = val => {
    inputs.forEach(input => (input.value = val));
  };

  const handleInputChange = e => {
    updateAllInputs(e.target.value);
  };

  const handleAddQuantity = quantityInput => {
    const currentValue = parseInt(quantityInput.value, 10);
    const newValue = currentValue + 1;

    updateAllInputs(newValue);
    quantityInput.dispatchEvent(new Event("change"));
  };

  const handleSubtractQuantity = quantityInput => {
    const currentValue = parseInt(quantityInput.value, 10);

    if (currentValue === 1) return;

    const newValue = currentValue - 1;
    updateAllInputs(newValue);
    quantityInput.dispatchEvent(new Event("change"));
  };

  const handleCartItemCount = (cartItemCount, quantity) => {
    const displayedItemCount = qs(".item_count", cartItemCount);

    cartItemCount.dataset.cartItemCount = quantity;
    displayedItemCount.textContent = quantity;
  };

  // check for multiple instances of quantity-input, e.g. product block or optional input in product form
  quantityWrappers.forEach(el => {
    const quantityIsForProductCard = el.closest(".product-item");
    // Product blocks can contain product cards that are not associated with the template product.
    if (quantityIsForProductCard) return;

    const quantityInput = qs("[data-quantity-input]", el);
    const addQuantity = qs("[data-add-quantity]", el);
    const subtractQuantity = qs("[data-subtract-quantity]", el);
    const cartItemCount = qs(
      "[data-cart-item-count]",
      el.previousElementSibling
    );

    // track all input instances to update all on change
    inputs.push(quantityInput);
    events.push(
      listen(addQuantity, "click", () => handleAddQuantity(quantityInput)),
      listen(subtractQuantity, "click", () =>
        handleSubtractQuantity(quantityInput)
      ),
      listen(quantityInput, "change", handleInputChange)
    );

    if (cartItemCount) {
      events.push(
        on(
          "theme-internal:update-quantity-selector-counts",
          ({ id, quantity }) => {
            if (parseInt(container.dataset.currentProductId, 10) === id) {
              handleCartItemCount(cartItemCount, quantity);
            }
          }
        )
      );
    }
  });

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
